module.exports = __webpack_public_path__ + "static/images/fields/lat_long_field.svg";